<template>
  <div>


    <b-container>
        <b-jumbotron header='Beta Testers Only'
        lead="Thanks for your interest! We are still testing our contracts before we make them public."
        >
            
        </b-jumbotron>
    <b-card>
        <div class="container text-center">
        <h3>Please enter the beta password to continue.</h3>

        <div class="row">
            <div class="col-md-6 offset-md-3">
            <form v-on:submit.prevent="validateBeforeSubmit">
                <div class="form-group text-left">
                <label class="custom-label control-label">Password</label>
                <input class="form-control password-field" type="password" name="password" v-model.trim="password">
                <span class="error help-block" ></span>
                </div>
                <div class="text-danger" v-if="error"><p>Incorrect password.</p></div>
                <button class="btn btn-primary" type="submit">Submit</button>
            </form>
            </div>
        </div>
        </div>
    </b-card>
    </b-container>
  </div>
</template>

<script>
//import storageHelper from 'storage-helper'
import router from '../router'
export default {
  data () {
    return {
      error: null,
      password: null
    }
  },
  methods: {
    validateBeforeSubmit () {
      if (this.password === 'vitetogether1') {
        this.error = false
        localStorage.userPassword = this.password
        router.push('/')
      } else {
        this.error = true
      }
    }
  }
}
</script>